"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ChargebackWebviewLoadedAnalyticsEvent = exports.ChargebackWebviewErrorAnalyticsEvent = exports.ChargebackWebviewDismissedAnalyticsEvent = exports.ChargebackSessionInitiationAttemptedAnalyticsEvent = exports.ChargebackSessionCtaClickedAnalyticsEvent = exports.ChargebackModalCloseButtonClickedAnalyticsEvent = exports.ChargebackGenerateUrlSuccessAnalyticsEvent = exports.ChargebackGenerateUrlErrorAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user clicks the Chargeback session CTA
 */
var ChargebackSessionCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('chargeback_session_cta_clicked');
exports.ChargebackSessionCtaClickedAnalyticsEvent = ChargebackSessionCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks the Chargeback modal CTA to open the Chargeback webview
 */
var ChargebackSessionInitiationAttemptedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('chargeback_session_initiation_attempted');
exports.ChargebackSessionInitiationAttemptedAnalyticsEvent = ChargebackSessionInitiationAttemptedAnalyticsEvent;
/**
 * Triggers when user clicks the Chargeback modal close button
 */
var ChargebackModalCloseButtonClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('chargeback_modal_close_button_clicked');
exports.ChargebackModalCloseButtonClickedAnalyticsEvent = ChargebackModalCloseButtonClickedAnalyticsEvent;
/**
 * Triggers when the Chargeback URL is successfully generated
 */
var ChargebackGenerateUrlSuccessAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('chargeback_generate_url_success');
exports.ChargebackGenerateUrlSuccessAnalyticsEvent = ChargebackGenerateUrlSuccessAnalyticsEvent;
/**
 * Triggers when the Chargeback URL generation fails
 */
var ChargebackGenerateUrlErrorAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('chargeback_generate_url_error');
exports.ChargebackGenerateUrlErrorAnalyticsEvent = ChargebackGenerateUrlErrorAnalyticsEvent;
/**
 * Triggers when user loads the Chargeback webview
 */
var ChargebackWebviewLoadedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('chargeback_webview_loaded');
exports.ChargebackWebviewLoadedAnalyticsEvent = ChargebackWebviewLoadedAnalyticsEvent;
/**
 * Triggers when user encounters an error in the Chargeback webview
 */
var ChargebackWebviewErrorAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('chargeback_webview_error');
exports.ChargebackWebviewErrorAnalyticsEvent = ChargebackWebviewErrorAnalyticsEvent;
/**
 * Triggers when user dismisses the Chargeback webview via a button in the webview
 */
var ChargebackWebviewDismissedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('chargeback_webview_dismissed');
exports.ChargebackWebviewDismissedAnalyticsEvent = ChargebackWebviewDismissedAnalyticsEvent;
